module.exports = __webpack_public_path__ + "img/silicium-high-purity-lv2.0c1024de.png";